import {
  Box,
  Card,
  CardContent,
  Grid,
  Grid2,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MaterialTypography from "../../components/MaterialTypography";
import { PureComponent } from "react";
import Chart from "./piechart/barchart";
import roundchart from "./piechart/roundchart";
import Roundchart from "./piechart/roundchart";
import PieChartSkeleton from "./piechart/RoundChartSkelton";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import CardSkelton from "./appointment/CardSkelton";
import BASEURL from "../Utils/Baseurl";
import request, { gql } from "graphql-request";
import PaperCard from "./PaperCard";
import AppointmentCard from "./appointment/AppointmentCard";
import ApexChart from "./apexChart/ApexBarChart";
import ApexPieChart from "./apexChart/ApexPieChart";
import { ApointmentNewCard } from "./appointment/ApointmentNewCard";
import NewApexChart from "./apexChart/NewApexChart";
import SalesCard from "./SalesCard";
import Ciclechart from "../../components/Chartreusable/Circlechart";
import Barchart from "../../components/Chartreusable/Barchart"
import Linechart from "../../components/Chartreusable/Linechart";
import TaskProgress from "./taskProgress";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import { fromGlobalId } from "../../lib/decoded/rawPk";
import { followUpAndOverdueTasksQuery, getTaskBreakdown, performanceAnalytics, taskDistributionQuery } from "./GraphQl";
import FollowUpTaskList from "./FollowUpTaskList";

const allAppointmentDetails = gql`
  query {
    allAppointmentDetails {
      contactPerson
      phoneNumber
      scheduledDate
      time
      withName
      name
    }
  }
`;

const data = [
  {
    id: 1,
    cname: "R Tamilpriyan",
    person: "Sowmiya",
    number: "9600902178",
    date: "2024-12-11",
    time: "10:40:00",
  },
  {
    id: 1,
    cname: "R Tamilpriyan",
    person: "Sowmiya",
    number: "9600902178",
    date: "2024-12-11",
    time: "10:40:00",
  },
  {
    id: 1,
    cname: "R Tamilpriyan",
    person: "Sowmiya",
    number: "9600902178",
    date: "2024-12-11",
    time: "10:40:00",
  },
  {
    id: 1,
    cname: "R Tamilpriyan",
    person: "Sowmiya",
    number: "9600902178",
    date: "2024-12-11",
    time: "10:40:00",
  },
];

const DashoardCard = () => {
  const { currentUser } = useAuth();
  const params = useLocation();
  const id = params.search.slice(1);
  const userRole = localStorage.getItem("userRole");
  const decodedId = atob(currentUser?.id);
  const userID = decodedId.split(":")[1];
  const [appointemntdata, setAppointmentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const  [taskBreakdownData, setTaskBreakdownData] = useState([]);
  const [taskDistributionData, setTaskDistributionData] = useState([]);
  const [ performanceAnalyticsData, setPerformanceAnalyticsData] = useState([]);
  const [ followupData, setFollowupData] = useState([]);


  useEffect(() => {
    setLoading(true);
    request(BASEURL, allAppointmentDetails)
      .then((res) => setAppointmentData(res.allAppointmentDetails))
      .catch((err) => setAppointmentData([]))
      .finally(() => setLoading(false));
  }, []);
  const renderContent = () => {
    if (loading) return <CardSkelton />;
    if (error)
      return <p style={{ color: "red", textAlign: "center" }}>{error}</p>;
    if (appointemntdata.length === 0)
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            margin: "10px 0px",
          }}
        >
          {/* <p>No Scheduled Appointment</p> */}
        </div>
      );
    return appointemntdata.map((item, index) => (
      <ApointmentNewCard key={index} v={item} i={index} />
    ));
    // return appointemntdata.map((item, index) => (
    //   <AppointmentCard key={index} v={item} i={index} />
    // ));
  };


const customColors = ['#FF8900', '#8E00b4', '#0091ca', '#00a91f'];

  const datas = [
    { name: 'Thiru', Completion: 4000, Response: 2400 },
    { name: 'Sowmi', Completion: 3000, Response: 1398 },
    { name: 'Sanjay', Completion: 2000, Response: 1000 },
    { name: 'Vijay', Completion: 2780, Response: 3908 },
    { name: 'Esakki', Completion: 1890, Response: 4800 },
  ];
   
  const colors = ['#E63946', '#2A9D8F'];

  useEffect(() => {
    fetchTaskDistribution();
  }, []);

  useEffect(() => {
    fetchPerformanceAnalytics();
  },[]);

  useEffect(() => {
    fetchFollowUpAndOverdueTasks();
  },[]);

  useEffect(() => {
    fetchTaskBreakdown();
  },[userID]);

//Task Break Down Pie Chart
  const fetchTaskBreakdown = async () => {
    try{
      const response = await request(BASEURL, getTaskBreakdown, {
        userId : userID
      });
      setTaskBreakdownData(response.taskStatusBreakdown.data);
    }
    catch(error){
      console.error("Error Fetching Data: ", error);
    }
  };

//Task Distribution Bar Chart
const fetchTaskDistribution = async () => {
  try {
    const response = await request(BASEURL, taskDistributionQuery);
    const data = response?.taskDistribution?.data || [];    
    setTaskDistributionData(data);
  } catch (err) {
    console.error("Error fetching task distribution:", err);
  }
};


//Performance Analytics
const fetchPerformanceAnalytics = async () => {
  try{
      const response = await request(BASEURL, performanceAnalytics)
      data= response?.performanceAnalytics?.data || [];
      setPerformanceAnalyticsData(data);
  }
  catch(error){
    console.error("Couldn't fetch data",error)
  }
}

//Followup and OverDue Tasks
const fetchFollowUpAndOverdueTasks = async () => {
  try{
      const response = await request(BASEURL, followUpAndOverdueTasksQuery,{
        id: userID
      })
      const data1= response?.followupAndOverdueTasks?.data;      
      setFollowupData(data1);
  }
  catch(error){
    console.error("Couldn't fetch data",error)
  }
}

  return (
    <div>
      <div className="appinot-main-box">{renderContent()}</div>
      <div className="padbottom">
      {/* <SalesCard /> */}
      </div>

      {/* <div className="Chat-bar-box">
        <div
          className="Chat-bar-box1"
          style={{
            width: "66%",
            height: "100%",
            padding: "10px 0px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          
          }}
        >
          <ApexChart />
         
        </div>
        <div>
          <ApexPieChart />
          
        </div>
      </div>
      <NewApexChart /> */}
      <Grid2 container spacing={2}  marginTop={1}>
        <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
              <FollowUpTaskList tasks={followupData}
              height={370}/>
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
          <Ciclechart data={taskBreakdownData} title="Task Status Breakdown" colors={customColors}
          height={300}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
            <Barchart
              data={taskDistributionData.map(item => ({
                name: item.salesperson,
                taskCount: item.taskCount,
              }))}
              title="Task Distribution"
              colors={colors}
              keys={['Task Count']}
              height={300}
            />

        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
          <Barchart
            data={performanceAnalyticsData.map(item => ({
              name: item.salesperson,
              completionRate: item.completionRate,
              pendingCount: item.pendingCount,
              avgResponseTime: item.avgResponseTime
            }))}
            title="Performance Analytics"
            colors={colors}
            keys={["Completion Rate", "Pending Count", "Avg Response Time"]}
            height={300}
          />
        </Grid2>
      </Grid2>
      {/* <SalesCard /> */}
          <TaskProgress/>

      <Grid2 container spacing={2}  marginTop={1}>
    
   
   
        {/* <Grid2 size={{ xs: 12, sm: 12, md: 12 }}>
        <Linechart  data={datas}
          title="Completion Rate vs Response Time"
          colors={colors}
          keys={['Completion', 'Response']} height={300}/>
        </Grid2> */}
      </Grid2>
    
    </div>
  );
};

export default DashoardCard;
